import { Component, Input, EventEmitter, Output} from '@angular/core';
import * as d3pie from 'd3pie';
import {DoughnutModel, CategoryData } from '../models/DoughtnutDetails';

@Component({
	selector: 'app-donut-chart',
	templateUrl: './doughnut.component.html'
})

export class DonutChartComponent  {  
    @Input() GraphData : any;
    @Input() TotalTicketCountInput : number;
	Xaxis=[];
	Yaxis=[];
    myData =[];
    model = new DoughnutModel;
    @Output() doughnutModel = new EventEmitter<DoughnutModel>(); 
	ngOnChanges() {
    document.getElementById('d3charts').innerHTML = ""
    this.createDoughNutData(this.GraphData) ;
    var that = this; 
    let pie : any = window;    
    if(this.GraphData != undefined)
    {  
	pie.pie = new d3pie("d3charts", {
    header: {
            "title": {
                "text": this.TotalTicketCountInput + " Tickets" ,
                "fontSize": 12,
            },
            "location": "pie-center",
        },
        
     size: {
        "canvasWidth": 210,
        "canvasHeight": 160,
		"pieInnerRadius": "55%",
		"pieOuterRadius": "100%"
    },
    labels: {
		"outer": {
			"format": "none",
        },
        "inner": {
            "format": "percentage",
            "hideWhenLessThanPercentage": 2,
            "color": "#333333",
            "fontSize": 9  	

        },
        "percentage": {
			"color": "#333333",
			"fontSize": 9  			
        },
        "mainLabel": {
            "fontSize": 9
        },
        "truncation": {
            "enabled": false
        },
    }, 
    data: {
        content: this.myData,
        },
    tooltips: {
		enabled: true,
		type: "placeholder",
        string: "{label}",
        //string: "{value}, {percentage}%",
		styles: {
			"backgroundOpacity": 0.86
		}
    },
    hide:{
        enabled : false
    },
    callbacks: {      
		onClickSegment: function (a) {
            if(a.data.label != "Unclassified")
            {
            document.getElementById('collaspedoughnut').classList.remove('col-12');
            document.getElementsByClassName('row myw-grid')[2].classList.remove('justify-content-center');                 
            document.getElementById('doughtchart').classList.remove('col-6');
            document.getElementById('legends').style.display = "none";   
            document.getElementById('showSegmentDetails').style.display = "block";   
            that.model.CategoryName = a.data.label;
            that.model.CategoryCount = a.data.catTicketcount;
            that.model.TotalCategoryCount = a.data.totalTicketCount;
            that.model.CategoryId = a.data.categoryId;
            that.model.CategoryPercentage = a.data.percentage;
            that.model.CategoryObservation = a.data.observation;
            that.model.CategoryNameList = a.data.categoryNameList;
            that.model.SubCategoryCount = a.data.noofSubCat;
            that.doughnutModel.emit(that.model)
            if(a.data.label == "Others")
            {
                document.getElementById('observationdiv').style.display = "none";
                document.getElementById('listcatgeorydiv').style.display = "block";   
            }
            else{
                document.getElementById('observationdiv').style.display = "block";
                document.getElementById('listcatgeorydiv').style.display = "none";   
            }
        }
		}
	}      
});
    }
}
    createDoughNutData(data:any){
    var totalCategoriesCount = 0;
    var totalPercentage = 0;
    var listedPercentage = 0;
    var listedTicketCount = 0;
    var otherPercentage = 0;
    var otherTicketCount = 0;   
    var unclassifiedCount = 0;   
    var catnameList : CategoryData [] = [];          
    this.myData.length  = 0;
    var colorList : any = [];   
    colorList.push("#55D8FE");
    colorList.push("#0FBF00");
    colorList.push("#FF8373");
    colorList.push("#FFDA83");
    colorList.push("#A3A0FB");
    colorList.push("#CA4F4F");

    if(data != undefined)
    {
        totalCategoriesCount = data.length;
 for(var i=0;i<data.length;i++){    
        totalPercentage = data[i]["Percentage"] + totalPercentage;
    }  
    unclassifiedCount = 100 - totalPercentage;   
    for(var i=0;i<data.length;i++){
        if(totalCategoriesCount == 6)
        {                                 
                this.myData.push({
                color: colorList[i],
                label: data[i]["CategoryName"], 
                categoryName : data[i]["CategoryName"], 
                categoryId : data[i]["CategoryId"],
                totalTicketCount : this.TotalTicketCountInput,
                value:data[i]["Percentage"],
                catTicketcount:data[i]["TicketCount"],
                noofSubCat : data[i]["SubCategoryCount"],
                observation :data[i]["formatObservation"], 
            });

        }
        else if(totalCategoriesCount < 6)
        {                       
                this.myData.push({
                color: colorList[i],
                label: data[i]["CategoryName"], 
                categoryName : data[i]["CategoryName"], 
                categoryId : data[i]["CategoryId"],
                totalTicketCount : this.TotalTicketCountInput,
                value:data[i]["Percentage"],
                catTicketcount:data[i]["TicketCount"],
                noofSubCat : data[i]["SubCategoryCount"],
                observation :data[i]["formatObservation"], 
                });
                
        }
        else  if(totalCategoriesCount > 6)
         if(this.myData.length < 5)
         {
            listedPercentage  = data[i]["Percentage"] + listedPercentage;
                listedTicketCount = data[i]["TicketCount"] + listedTicketCount;
                this.myData.push({
                color: colorList[i],
                label: data[i]["CategoryName"], 
                categoryName : data[i]["CategoryName"], 
                categoryId : data[i]["CategoryId"],
                totalTicketCount : this.TotalTicketCountInput,
                value:data[i]["Percentage"],
                catTicketcount:data[i]["TicketCount"],
                noofSubCat : data[i]["SubCategoryCount"],
                observation :data[i]["formatObservation"], 
            })
           
        }
        else{
            otherTicketCount = data[0]["TotalTicketCount"] - listedTicketCount
            otherPercentage = totalPercentage - listedPercentage;               
            catnameList.push({CategoryId: data[i]["CategoryId"],CategoryPercentage:data[i]["Percentage"],CategoryObservation:data[i]["formatObservation"], severityData: data[i]["SeverityData"], SubCategoryDetails: null, CategoryNameList: null, CategoryName:data[i]["CategoryName"], CategoryTicketCount: data[i]["TicketCount"], AllCategoryDetails: null});
            if(this.myData.length == 5)
            {
                this.myData.push({
                    color: colorList[5],
                    label:"Others",
                    value:otherPercentage,
                    totalTicketCount : this.TotalTicketCountInput,
                    catTicketcount : otherTicketCount,   
                    noofSubCat : (totalCategoriesCount - 5),  
                    categoryNameList : catnameList              
                })
                
            }
        }
    }
    this.myData.push({
        label: "Unclassified",   
        value:unclassifiedCount,
        color: "#EBFA04"
        });
    }     
  }
}
